import React, { Component } from "react";
import "./footer.css";
import { Link } from "react-router-dom";

class Footer extends Component {
  render() {
    return (
      <section id="footer" className="footer-area bg_cover">
        <div className="footer-widget">
          <div className="container">
            <div className="widget pt-80 pb-130">
              <div className="row">
                <div className="col-lg-6">
                  <div className="footer-address mt-40">
                    <h5 className="f-title">Venue Location</h5>
                    <p className="text">
                      8<sup>th</sup> July  - 9<sup>th</sup> July  2022
                      <br />K.C. College of Engineering and Management Studies and Research, Thane, Maharashtra, India
                    </p>
                    <Link className="contact-link" to="/contact">
                      Contact Our Authority
                    </Link>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="footer-contact mt-40">
                    <h5 className="f-title">Connect with us</h5>
                    <p className="text">
                      Want to keep a track of th event? Be sure to follow us on
                      the links below
                    </p>
                    <ul className="social">
                      <li>
                        <a
                          href="#"
                          target="_blank"
                          aria-label="Facebook"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          target="_blank"
                          aria-label="Twitter"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          target="_blank"
                          aria-label="Linkedin"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="#"
                          target="_blank"
                          aria-label="Instagram"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright text-center">
                  <p className="text">
                    Copyright © 2022 K. C. College of Engineering and Management Studies and Research.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Footer;
